import React, { useState } from "react";
import Table from "../../../../common/element/Table";
import Button from "../../../../common/element/Buttons";
import { useNavigate } from "react-router-dom";
import CopyLinkURLModal from "./CopyLink";
import DeleteModal from "../../../../common/Common/DeleteModal";
import ThreeDotBouncingLoader from "../../../../common/element/ButtonLoader/ThreeDotBouncingLoder";
import { useDispatch } from "react-redux";
import { deleteCompanyProspect, getCompanyProspectListing } from "../../../../redux/ProspectCompany/companyProspectSlice";
import { getCompanyProspectGeneratedUrlAPI } from "../../../../redux/ProspectCompany/companyProspectApi";
import SweetAlertService from "../../../../common/SweetAlert/SweetAlert";
import CommonIconButton from "../../../../common/icons/CommonIconButton";

const { Tr, Th, Td, THead, TBody } = Table;

const ProspectCompanyList = ({ sampleData, onEdit, onConvert, isLoading, filterpage, filterlimit, search }) => {
  const dispatch = useDispatch();
  const [mainCheck, setMainCheck] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const [openCopyLinkURLModal, setOpenCopyLinkURLModal] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [fetchingUrlId, setFetchingUrlId] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [convertTarget, setConvertTarget] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isConvertOpen, setIsConvertOpen] = useState(false);
  const navigate = useNavigate();

  const handleCopyLinkOpen = async (item) => {
    // Fetch generated URL from API and then open the modal with the response
    try {
      setFetchingUrlId(item.company_id);
      const response = await getCompanyProspectGeneratedUrlAPI(item.company_id);
      // response may come as { data: { generatedUrl: '...' } } or directly { generatedUrl: '...' } or a string
      const data = response?.data || response;
      const url = data?.generatedUrl || data?.url || (typeof data === "string" ? data : "");
      setSelectedCompany({ ...item, generateUrl: url });
      setOpenCopyLinkURLModal(true);
    } catch (error) {
      SweetAlertService.showError({
        title: "Error!",
        message: error?.response?.data?.message || error?.message || "Failed to fetch generated URL. Please try again.",
      });
    } finally {
      setFetchingUrlId(null);
    }
  };

  const handleDeleteOpen = (item) => {
    setDeleteTarget(item);
    setIsOpen(true);
  };

  const handleConvertOpen = (item) => {
    setConvertTarget(item);
    setIsConvertOpen(true);
  };

  const handleDeleteConfirm = () => {
    if (!deleteTarget) return;
    setIsDeleting(true);
    dispatch(deleteCompanyProspect(deleteTarget.company_id)).then((action) => {
      setIsDeleting(false);
      setIsOpen(false);
      setDeleteTarget(null);
      if (action.meta.requestStatus === "fulfilled") {
        SweetAlertService.showSuccess({
          title: "Deleted!",
          message: "Prospect company has been deleted successfully.",
        });
        dispatch(getCompanyProspectListing({ page: filterpage, limit: filterlimit, search }));
      } else {
        SweetAlertService.showError({
          title: "Error!",
          message: action.payload || "Failed to delete prospect company. Please try again.",
        });
      }
    });
  };

  const handleConvertConfirm = () => {
    setIsConvertOpen(false);
    if (onConvert && convertTarget) {
      onConvert(convertTarget);
    }
  };

  return (
    <>
      <div className="border rounded-lg border-gray-200">
        <Table>
          <THead>
            <Tr className="text-start">
              <Th className="text-start">S No.</Th>
              <Th className="text-start">Name</Th>
              <Th className="text-start">Contact Person</Th>
              <Th className="text-start">HR Name</Th>
              <Th className="text-start">HR Phone No.</Th>
              <Th className="text-start">HR Email</Th>
              <Th className="text-start">Action</Th>
            </Tr>
          </THead>

          <TBody>
            {isLoading ? (
              <Tr>
                <Td colSpan={7} className="text-center py-8">
                  <div className="flex justify-center items-center">
                    <ThreeDotBouncingLoader />
                  </div>
                </Td>
              </Tr>
            ) : sampleData.length > 0 ? (
              sampleData.map((item, index) => (
                <Tr key={item.company_id} className="text-start">
                  <Td className="text-start">{String(((Number(filterpage) || 1) - 1) * (Number(filterlimit) || sampleData.length) + index + 1).padStart(2, "0")}</Td>
                  <Td className="text-start">{item.company_name ? item.company_name : "—"}</Td>
                  <Td className="text-start">{item.contact_person ? item.contact_person : "—"}</Td>
                  <Td className="text-start">{item.hr?.first_name ? item.hr?.first_name + item.hr?.last_name : "—"}</Td>
                  <Td className="text-start">{item.hr?.mobile_number ? item.hr?.mobile_number : "—"}</Td>
                  <Td className="text-start">{item.hr?.email ? item.hr?.email : "—"}</Td>
                  <Td className="text-start">
                    <div className="flex gap-1">
                      {/* View Button */}
                      <CommonIconButton
                        type="view"
                        onClick={() => navigate(`/prospectCompany/view?id=${item.company_id}`)} />


                      {/* Edit Button */}
                      <CommonIconButton
                        type="edit"
                        onClick={() => onEdit(item)} />


                      {/* Archive/Delete Button */}
                      <CommonIconButton
                        type="delete"
                        onClick={() => handleDeleteOpen(item)}
                      />

                      {/* convert company */}

                      <CommonIconButton type="convert" label='Convert Company' onClick={() => handleConvertOpen(item)} />

                      {/* Link Button */}
                      <p
                        className="w-10 h-10 flex items-center justify-center"
                        onClick={() => handleCopyLinkOpen(item)}
                        disabled={fetchingUrlId === item.company_id}
                      >
                        {fetchingUrlId === item.company_id ? (
                          <div className="w-5 h-5 flex items-center justify-center">
                            <ThreeDotBouncingLoader />
                          </div>
                        ) : (
                          <CommonIconButton type="link" />
                        )}
                      </p>





                    </div>
                  </Td>
                </Tr>
              ))
            ) : (
              <Tr>
                <Td colSpan={7} className="text-center text-gray-500 py-6 text-sm">
                  No matching records found
                </Td>
              </Tr>
            )}
          </TBody>
        </Table>

        <DeleteModal
          dialogOpen={isOpen}
          onDialogClose={() => { setIsOpen(false); setDeleteTarget(null); }}
          onConfirm={handleDeleteConfirm}
          isLoading={isDeleting}
          title="Are you sure you want to delete?"
          subtitle="This action cannot be undone. This will permanently delete the prospect company."
        />
        <DeleteModal
          dialogOpen={isConvertOpen}
          onDialogClose={() => { setIsConvertOpen(false); setConvertTarget(null); }}
          onConfirm={handleConvertConfirm}
          title="Are you sure you want to convert?"
          subtitle="This will convert the prospect company to a regular company. You will be able to fill in more details."
        />
        <CopyLinkURLModal
          dialogOpen={openCopyLinkURLModal}
          onDialogClose={() => setOpenCopyLinkURLModal(false)}
          onSubmit={() => setOpenCopyLinkURLModal(false)}
          companyData={selectedCompany}
        />
      </div>
    </>
  );
};

export default ProspectCompanyList;